export enum ACTIONS {
	START_WATCHING_REGION = 'START_WATCHING_REGION',
	END_WATCHING_REGION = 'END_WATCHING_REGION',
}
